import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { IconOutcomesLine } from '@instructure/ui-icons';
import { Button } from '@instructure/ui-buttons';
import { Text } from '@instructure/ui-text';
import OutcomeCount from '@instructure/outcomes-ui/es/containers/OutcomeCount';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { liveRegion, END_EDITING_TRIGGER_CLASSNAME } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/format-message';
import { makeEditable } from '@instructure/quiz-core';
var OutcomesEditButtonPresenter = /*#__PURE__*/function (_Component) {
  function OutcomesEditButtonPresenter() {
    _classCallCheck(this, OutcomesEditButtonPresenter);
    return _callSuper(this, OutcomesEditButtonPresenter, arguments);
  }
  _inherits(OutcomesEditButtonPresenter, _Component);
  return _createClass(OutcomesEditButtonPresenter, [{
    key: "color",
    value: function color() {
      return this.props.isEditing ? 'secondary' : 'primary-inverse';
    }
  }, {
    key: "statusText",
    value: function statusText() {
      if (this.props.isEditing) {
        return t('Outcomes panel open, click to close');
      } else {
        return t('Outcomes panel closed, click to open');
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Button, {
        color: this.color(),
        onClick: this.props.toggleEditing,
        renderIcon: IconOutcomesLine,
        "data-automation": "sdk-outcomes-edit-button",
        className: END_EDITING_TRIGGER_CLASSNAME
      }, /*#__PURE__*/React.createElement(Text, {
        size: "small"
      }, t('Outcomes'), "\xA0", /*#__PURE__*/React.createElement(OutcomeCount, {
        artifactId: this.props.quiz.id,
        artifactType: "quiz",
        alignmentSetId: this.props.quiz.outcomeAlignmentSetGuid,
        contextUuid: this.props.contextUuid,
        host: this.props.outcomesEndpoint,
        jwt: this.props.outcomesToken,
        screenreaderNotification: this.props.screenreaderNotification,
        liveRegion: liveRegion
      }), /*#__PURE__*/React.createElement(ScreenReaderContent, null, this.statusText())));
    }
  }]);
}(Component);
_defineProperty(OutcomesEditButtonPresenter, "propTypes", {
  quiz: ImmutablePropTypes.record.isRequired,
  contextUuid: PropTypes.string.isRequired,
  isEditing: PropTypes.bool,
  toggleEditing: PropTypes.func.isRequired,
  outcomesEndpoint: PropTypes.string.isRequired,
  outcomesToken: PropTypes.string.isRequired,
  screenreaderNotification: PropTypes.func.isRequired
});
_defineProperty(OutcomesEditButtonPresenter, "defaultProps", {
  isEditing: false
});
export var OutcomesEditButton = makeEditable(OutcomesEditButtonPresenter);
export default OutcomesEditButton;